/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Tabitha Bleil
 */

import React from "react"

import {
    TitleSection,
    ModalTitle,
    ContentSection,
    Column,
    Element,
    Label,
    Button,
    Color,
    isSmallMobileScreen,
    FooterSection,
} from "trux"
import inviteFamily from "../assets/invite-family.svg"

export const InviteFamily = ({
    loggedInUser,
    onAddFamily,
    onSkip,
    ...props
}) => {
    const onLoad = () => {
        var x = document.getElementById("image-background")
        var y = document.getElementById("image")

        x.style.display = "none"
        y.style.display = "inline-block"
    }
    return (
        <>
            <TitleSection>
                <ModalTitle content="Invite family to watch" />
            </TitleSection>
            <ContentSection>
                <Column center span="12" className="form">
                    <Element
                        className="image-background"
                        id="image-background"
                        marginBottom="4"
                    ></Element>
                    <Element
                        tag="img"
                        src={inviteFamily}
                        marginBottom="4"
                        className="image"
                        id="image"
                        onLoad={onLoad}
                    />

                    <Element className="text-contents">
                        <Label
                            color={Color.Charcoal40}
                            marginBottom="8"
                            content={`Invite more family members to be automatically emailed ${loggedInUser.first_name}'s Trace video!`}
                        />
                    </Element>
                    {!isSmallMobileScreen() && (
                        <Element className="button-container">
                            <Button
                                type={Label.Type.Heading5}
                                className="button"
                                marginBottom="3"
                                onClick={onAddFamily}
                                content={
                                    <Label
                                        type={Label.Type.InnerButton}
                                        content="Invite a family member"
                                    />
                                }
                            />
                            <Button
                                className="other-button"
                                width="100%"
                                type={Label.Type.SmallBody}
                                onClick={onSkip}
                                content="Skip"
                            />
                        </Element>
                    )}
                </Column>
            </ContentSection>
            {isSmallMobileScreen() && (
                <FooterSection>
                    <Button
                        className="button"
                        marginBottom="5"
                        onClick={onAddFamily}
                        content={
                            <Label
                                type={Label.Type.InnerButton}
                                content="Invite a family member"
                            />
                        }
                    />
                    <Button
                        className="other-button"
                        type={Label.Type.SmallBody}
                        onClick={onSkip}
                        content="Skip"
                        center
                    />
                </FooterSection>
            )}
        </>
    )
}
